'use client';

import { useCallback, useState } from 'react';
import { useWizardContext } from '../../hooks/useWizardContext';
import { useWizardNavigation } from '../../hooks/useWizardNavigation';
import type { PcpStatusType } from '../../types';
import { RadioGroup } from '../shared/RadioGroup';
import { StepLayout } from '../shared/StepLayout';

const PCP_STATUS_OPTIONS = [
  {
    value: 'Yes, I have a concierge primary care physician',
    label: 'Yes, I have a concierge primary care physician',
  },
  {
    value: 'Yes, I have a traditional primary care physician',
    label: 'Yes, I have a traditional primary care physician',
  },
  {
    value: "No, I don't currently have a primary care physician",
    label: "No, I don't currently have a primary care physician",
  },
  { value: "I'm not sure", label: "I'm not sure" },
];

/**
 * PcpStatus step - asks whether the user has a primary care physician.
 */
export function PcpStatusStep() {
  const { state, dispatch } = useWizardContext();
  const { goToNextStep, goToPreviousStep, hasPreviousStep } =
    useWizardNavigation();
  const [error, setError] = useState<string | undefined>();

  // Read directly from wizard state
  const pcpStatus = state.formData?.pcp_status;

  const handleChange = useCallback(
    (value: string) => {
      dispatch({
        type: 'SET_FORM_DATA',
        payload: { pcp_status: value as PcpStatusType },
      });
      setError(undefined);
    },
    [dispatch]
  );

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();

      if (!pcpStatus) {
        setError('Please select an option');
        return;
      }

      goToNextStep();
    },
    [pcpStatus, goToNextStep]
  );

  return (
    <StepLayout
      heading='Do you currently have a primary care physician (PCP)?'
      description='Sollis coordinates with your doctor to ensure continuity of care while handling your immediate medical needs.'
      onSubmit={handleSubmit}
      onBack={goToPreviousStep}
      showBack={hasPreviousStep}
    >
      <RadioGroup
        name='pcp_status'
        options={PCP_STATUS_OPTIONS}
        value={pcpStatus}
        onChange={handleChange}
        error={error}
      />
    </StepLayout>
  );
}
